module.exports = __webpack_public_path__ + "freshyou/web/manager/img/copy.92ed12c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/copy.png
// module id = OG1+
// module chunks = 1